<template>

    <div>

        <v-card-text v-if="session.user_data != null">
           {{ $t("erp.widgets.greeting",{name: session.user_data.first_name}) }} {{$t("erp.widgets.greeting_text")}}
        </v-card-text>

    </div>

</template>


<script>

    import { sessionStore } from '@/store/pinia/sessionStore'



    export default {

        name: 'welcomeWidget.vue',
        wconf: {

            title: 'dashboard.widget.title.welcome',
            location: 'primary',
            position: 10,
            active: true

        },

      setup() {

        const session = sessionStore();

        return {
          // you can return the whole store instance to use it in the template
          session,
        }

      },

        methods: {


            getTitle(){

                return this.$t('dashboard.widget.title.welcome')

            }

        },



        mounted() {},

        created(){}



    }



</script>
